import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import HomePage from "./pages/HomePage";
import SingleMooviePage from "./pages/SingleMooviePage";

function App() {
  return (
    <Router>
      <Switch>
        <Route path='/' exact>
          <HomePage />
        </Route>
        <Route path='/movie/:imdbID'>
          <SingleMooviePage />
        </Route>
        <Route path='*'>
          <Redirect to='/' />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
